// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
// import { useCart } from '../context/CartContext';
// import {
//   FiShoppingCart, FiUser, FiSearch, FiMenu, FiX,
//   FiLogOut, FiPackage, FiSettings, FiChevronDown,
//   FiPhone, FiMail, FiTruck, FiGrid
// } from 'react-icons/fi';
// import './Navbar.css';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import {
  FiShoppingCart, FiUser, FiSearch, FiMenu, FiX,
  FiLogOut, FiPackage, FiSettings, FiChevronDown,
  FiPhone, FiMail, FiTruck, FiGrid
} from 'react-icons/fi';
import './Navbar.css';

const CATEGORIES = [
  {
    name: 'Laser Printer Parts',
    icon: '🖨️',
    sub: ['Fuser Sleeve / Teflon', 'Power Supply / DC Board', 'Formatter Board', 'ECU / Engine Control Unit', 'Control Panel', 'CCD Scanner / CIS Head', 'Pickup Assembly', 'Toner Sensor Lever', 'Relay / Solenoid', 'Pressure Roller Bush', 'Clutch Gear', 'Fuser Grease'],
    groups: [
      { title: 'Pickup Parts',      items: ['Pickup Rubber Tire', 'Pickup Roller', 'Paper Pickup Assembly', 'Tray & Separation Pad', 'ADF Roller Kit', 'Hinge, Lever & Sensor'] },
      { title: 'Fuser Parts',       items: ['Fuser Assembly', 'Fuser Film', 'Fuser Heater', 'Paper Exit Roller', 'Bush', 'Upper Fuser Roller', 'Pressure Roller', 'Fuser Sleeve / Teflon'] },
      { title: 'Printer Supplies',  items: ['Gears', 'Power Supply', 'ECU Card', 'Laser / CCD Scanner', 'Control Panel', 'Motor', 'Printer Covers', 'Formatter Board'] },
      { title: 'Cables & Sensors',  items: ['Head Cable', 'Panel Cable', 'Sensor Cable', 'Toner Sensor Lever', 'Relay / Solenoid', 'Clutch Gear', 'Fuser Grease'] },
    ]
  },
  {
    name: 'Inkjet Printer Parts',
    icon: '💧',
    sub: ['Pump Assembly', 'Waste Ink Pad', 'Maintenance Box', 'Encoder Strip', 'Head Cable', 'PF Sensor Cable', 'Pickup Roller', 'CCD Scanner', 'Power Supply', 'Formatter Board', 'Carriage Motor', 'Ink Pipe / Tube'],
    groups: [
      { title: 'InkJet Parts',       items: ['Ink Waste Pad', 'Ink Printer Parts', 'Ink', 'Maintenance Box', 'Carriage Assembly / PCB', 'Encoder Disk / Strip', 'Carriage Belt'] },
      { title: 'Pickup Parts',       items: ['Pickup Rubber Tire', 'Pickup Roller', 'Paper Pickup Assembly', 'Tray & Separation Pad', 'ADF Roller Kit'] },
      { title: 'Fuser Parts',        items: ['Fuser Assembly', 'Fuser Film', 'Paper Exit Roller', 'Bush', 'Upper Fuser Roller', 'Pressure Roller'] },
      { title: 'Printer Supplies',   items: ['Gears', 'Power Supply', 'ECU Card', 'Laser / CCD Scanner', 'Control Panel', 'Motor', 'Printer Covers'] },
    ]
  },
  {
    name: 'DMP Printer Parts',
    icon: '📠',
    sub: ['Head Cable', 'PF Gear', 'Timing Belt', 'Ribbon Drive Board', 'Knob', 'Mylar Strip', 'Leaf Sensor', 'Combination Gear', 'Head Wheel / Roller', 'Power Supply'],
    groups: [
      { title: 'DMP Parts',          items: ['Head Cable', 'PF Gear', 'Timing Belt', 'Ribbon Drive Board', 'Knob', 'Mylar Strip'] },
      { title: 'Mechanical Parts',   items: ['Leaf Sensor', 'Combination Gear', 'Head Wheel / Roller', 'Power Supply', 'Print Head'] },
      { title: 'Cables & Boards',    items: ['Formatter Board', 'Panel Cable', 'Sensor Cable', 'Relay / Solenoid'] },
      { title: 'Consumables',        items: ['Ribbon Cartridge', 'Platen Roller', 'Paper Guide', 'Bail Roller'] },
    ]
  },
  {
    name: 'Scanner Parts',
    icon: '🔍',
    sub: ['Pickup Roller Kit', 'USB Cable', 'Formatter Board', 'CIS / CCD Head', 'Scanner Cable', 'Contact Image Sensor'],
    groups: [
      { title: 'Scanner Parts',      items: ['Pickup Roller Kit', 'CIS / CCD Head', 'Contact Image Sensor', 'ADF Roller Kit', 'Separation Pad'] },
      { title: 'Cables & Boards',    items: ['USB Cable', 'Scanner Cable', 'Formatter Board', 'Panel Cable', 'Power Supply'] },
      { title: 'Mechanical Parts',   items: ['Hinge Assembly', 'Carriage Belt', 'Carriage Motor', 'Paper Exit Roller'] },
      { title: 'Accessories',        items: ['Glass Platen', 'Document Cover', 'ADF Assembly', 'Lamp / Light Source'] },
    ]
  },
  {
    name: 'Thermal / POS Printer Parts',
    icon: '🧾',
    sub: ['Thermal Print Head', 'Auto Cutter Unit', 'Paper Cutter', 'Formatter Board', 'Power Adapter', 'PF Gear', 'Cutter Blade'],
    groups: [
      { title: 'Thermal Parts',      items: ['Thermal Print Head', 'Auto Cutter Unit', 'Paper Cutter', 'Cutter Blade', 'Platen Roller'] },
      { title: 'Boards & Power',     items: ['Formatter Board', 'Power Adapter', 'Main Board', 'Interface Board'] },
      { title: 'Mechanical Parts',   items: ['PF Gear', 'Paper Feed Motor', 'Paper Sensor', 'Cover Assembly'] },
      { title: 'Accessories',        items: ['Paper Roll Holder', 'Power Cable', 'USB Cable', 'Cash Drawer Cable'] },
    ]
  },
  {
    name: 'Toner Spare Parts',
    icon: '🖤',
    sub: ['OPC Drum', 'Toner Powder', 'Wiper Blade', 'Maintenance Box Chip', 'Fuser Grease'],
    groups: [
      { title: 'Toner Parts',        items: ['OPC Drum', 'Toner Powder', 'Wiper Blade', 'Doctor Blade', 'Magnetic Roller'] },
      { title: 'Cartridge Spares',   items: ['Developer Roller', 'Chip Reset', 'Drum Unit', 'Drum Blade', 'PCR Roller'] },
      { title: 'Fuser Parts',        items: ['Fuser Assembly', 'Fuser Film', 'Pressure Roller', 'Fuser Heater', 'Thermistor'] },
      { title: 'Accessories',        items: ['Maintenance Box Chip', 'Fuser Grease', 'Waste Toner Bottle', 'Transfer Belt'] },
    ]
  },
  {
    name: 'Tool / Kit',
    icon: '🔧',
    sub: ['Screwdriver Set', 'Cleaning Kit', 'Fuser Grease Kit', 'Roller Replacement Kit', 'Maintenance Kit', 'Spanner Set', 'Diagnostic Tool', 'Drum Reset Kit'],
    groups: [
      { title: 'Hand Tools',         items: ['Screwdriver Set', 'Spanner Set', 'Plier Set', 'Torx Key Set', 'Hex Key Set'] },
      { title: 'Cleaning Kits',      items: ['Cleaning Kit', 'Foam Swabs', 'IPA Cleaner', 'Lint Free Cloth', 'Drum Cleaning Kit'] },
      { title: 'Maintenance Kits',   items: ['Fuser Grease Kit', 'Roller Replacement Kit', 'Maintenance Kit', 'Drum Reset Kit'] },
      { title: 'Diagnostic Tools',   items: ['Diagnostic Tool', 'Test Page Tool', 'Voltage Tester', 'Multimeter'] },
    ]
  }
];

const BRANDS = ['HP', 'Canon', 'Epson', 'Brother', 'TVS', 'Samsung', 'Ricoh', 'Kyocera'];

export default function Navbar() {
  const { user, logout }  = useAuth();
  const { cartCount }     = useCart();
  const navigate          = useNavigate();
  const [search,          setSearch]          = useState('');
  const [menuOpen,        setMenuOpen]        = useState(false);
  const [userMenuOpen,    setUserMenuOpen]    = useState(false);
  const [activeDropdown,  setActiveDropdown]  = useState(null);
  const [allCatOpen,      setAllCatOpen]      = useState(false);
  const dropdownTimerRef = React.useRef(null);

  const openDropdown = (name) => {
    if (dropdownTimerRef.current) clearTimeout(dropdownTimerRef.current);
    setActiveDropdown(name);
  };
  const closeDropdown = () => {
    dropdownTimerRef.current = setTimeout(() => setActiveDropdown(null), 120);
  };
  const openAllCat = () => {
    if (dropdownTimerRef.current) clearTimeout(dropdownTimerRef.current);
    setAllCatOpen(true);
  };
  const closeAllCat = () => {
    dropdownTimerRef.current = setTimeout(() => setAllCatOpen(false), 120);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (search.trim()) { navigate(`/products?keyword=${encodeURIComponent(search)}`); setSearch(''); setMenuOpen(false); }
  };

  const handleLogout = () => { logout(); navigate('/'); setUserMenuOpen(false); };

  return (
    <header className="site-header">

      {/* ── Top utility bar ── */}
      <div className="top-bar">
        <div className="container top-bar-inner">
          <div className="top-bar-left">
            <span><FiPhone size={11} /> +91 8467025204</span>
            <span><FiMail size={11} /> info@printerpartspare.com</span>
            <span><FiTruck size={11} /> All prices exclusive of 18% GST</span>
          </div>
          <div className="top-bar-right">
            {!user ? (
              <><Link to="/login">Sign In</Link><span>|</span><Link to="/register">Create Account</Link></>
            ) : (
              <span>Welcome, {user.name.split(' ')[0]}</span>
            )}
            <span>|</span>
            <Link to="/orders">Track Order</Link>
          </div>
        </div>
      </div>

      {/* ── Main header ── */}
      <div className="main-header">
        <div className="container main-header-inner">

          {/* Logo */}
          <Link to="/" className="site-logo">
            <img src="/logo.jpeg" alt="PrinterPartSpare" style={{ height: '42px', width: '42px', borderRadius: '50%', objectFit: 'cover' }} />
            <div className="logo-text">
              <span className="logo-name">PrinterPart<span className="logo-pro">Spare</span></span>
              <span className="logo-tagline">Ap Tech Solution.</span>
            </div>
          </Link>

          {/* Search */}
          <form onSubmit={handleSearch} className="header-search">
            <div className="search-category-select">
              <select defaultValue="">
                <option value="">All Categories</option>
                {CATEGORIES.map(c => <option key={c.name} value={c.name}>{c.name}</option>)}
              </select>
            </div>
            <input
              type="text"
              placeholder="Search by part number, printer model or keyword..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
            <button type="submit" className="search-go-btn"><FiSearch size={18} /></button>
          </form>

          {/* Actions */}
          <div className="header-actions">
            {user ? (
              <div className="user-menu-wrapper">
                <button className="header-action-btn" onClick={() => setUserMenuOpen(v => !v)}>
                  <div className="user-avatar-sm">{user.name[0]}</div>
                  <div className="header-action-text">
                    <span className="action-label">My Account</span>
                    <span className="action-value">{user.name.split(' ')[0]}</span>
                  </div>
                  <FiChevronDown size={13} />
                </button>
                {userMenuOpen && (
                  <div className="user-dropdown dropdown-anim">
                    <div className="dropdown-user-info">
                      <div className="user-avatar-sm lg">{user.name[0]}</div>
                      <div>
                        <strong>{user.name}</strong>
                        <span>{user.email}</span>
                      </div>
                    </div>
                    <div className="dropdown-divider" />
                    <Link to="/profile"  onClick={() => setUserMenuOpen(false)}><FiUser    size={14} /> My Profile</Link>
                    <Link to="/orders"   onClick={() => setUserMenuOpen(false)}><FiPackage size={14} /> Order History</Link>
                    {user.role === 'admin' && (
                      <Link to="/admin" onClick={() => setUserMenuOpen(false)}><FiSettings size={14} /> Admin Panel</Link>
                    )}
                    <div className="dropdown-divider" />
                    <button onClick={handleLogout} className="logout-btn"><FiLogOut size={14} /> Sign Out</button>
                  </div>
                )}
              </div>
            ) : (
              <Link to="/login" className="header-action-btn">
                <FiUser size={21} />
                <div className="header-action-text">
                  <span className="action-label">Sign In</span>
                  <span className="action-value">My Account</span>
                </div>
              </Link>
            )}

            <Link to="/cart" className="header-cart-btn">
              <div className="cart-icon-wrap">
                <FiShoppingCart size={21} />
                {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
              </div>
              <div className="header-action-text">
                <span className="action-label">Shopping</span>
                <span className="action-value">Cart</span>
              </div>
            </Link>
          </div>

          <button className="mobile-hamburger" onClick={() => setMenuOpen(v => !v)}>
            {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>
      </div>

      {/* ── Category nav ── */}
      <nav className="category-nav" onMouseLeave={closeDropdown}>
        <div className="container category-nav-inner">

          {/* All Categories mega button */}
          <div
            className="all-categories-btn-wrap"
            onMouseEnter={openAllCat}
            onMouseLeave={closeAllCat}
          >
            <button className="all-categories-btn">
              <FiGrid size={14} /> All Categories <FiChevronDown size={12} />
            </button>
            {allCatOpen && (
              <div className="mega-dropdown dropdown-anim" onMouseEnter={openAllCat} onMouseLeave={closeAllCat}>
                <p className="mega-dropdown-title">Shop by Category</p>
                {CATEGORIES.map(cat => (
                  <Link
                    key={cat.name}
                    to={`/products?category=${encodeURIComponent(cat.name)}`}
                    className="mega-cat-item"
                    onClick={() => setAllCatOpen(false)}
                  >
                    <span className="mega-cat-icon-wrap">{cat.icon}</span>
                    <div>
                      <span className="mega-cat-name">{cat.name}</span>
                      <span className="mega-cat-count">{cat.sub.length} parts</span>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>

          <div className="nav-divider" />

          {/* Per-category nav links — mega panel rendered OUTSIDE scroll container */}
          <div className="nav-cats-scroll">
            {CATEGORIES.map(cat => (
              <div
                key={cat.name}
                className={`nav-cat-item${activeDropdown === cat.name ? ' is-open' : ''}`}
                onMouseEnter={() => openDropdown(cat.name)}
                onMouseLeave={closeDropdown}
              >
                <Link
                  to={`/products?category=${encodeURIComponent(cat.name)}`}
                  className="nav-cat-link"
                >
                  <span className="nav-cat-emoji">{cat.icon}</span>
                  {cat.name} <FiChevronDown size={10} />
                </Link>
              </div>
            ))}

            <div className="nav-divider" />

            {/* Brand quick-links */}
            {BRANDS.map(b => (
              <Link key={b} to={`/products?brand=${b}`} className="nav-brand-link">{b}</Link>
            ))}
          </div>
        </div>

        {/* ── Mega panel rendered here — direct child of <nav> so it spans full width ── */}
        {activeDropdown && (() => {
          const cat = CATEGORIES.find(c => c.name === activeDropdown);
          if (!cat) return null;
          return (
            <div
              className="mega-panel dropdown-anim"
              onMouseEnter={() => openDropdown(cat.name)}
              onMouseLeave={closeDropdown}
            >
              <div className="mega-panel-cols">
                {(cat.groups || []).map(group => (
                  <div key={group.title} className="mega-col">
                    <p className="mega-col-title">{group.title}</p>
                    {group.items.map(item => (
                      <Link
                        key={item}
                        to={`/products?keyword=${encodeURIComponent(item)}`}
                        className="mega-col-link"
                        onClick={() => setActiveDropdown(null)}
                      >
                        {item}
                      </Link>
                    ))}
                  </div>
                ))}
              </div>
              <div className="mega-panel-footer">
                <Link
                  to={`/products?category=${encodeURIComponent(cat.name)}`}
                  className="mega-panel-view-all"
                  onClick={() => setActiveDropdown(null)}
                >
                  View all {cat.name} →
                </Link>
              </div>
            </div>
          );
        })()}
      </nav>

      {/* ── Mobile menu ── */}
      {menuOpen && (
        <div className="mobile-nav">
          <form onSubmit={handleSearch} className="mobile-search">
            <input type="text" placeholder="Search parts..." value={search} onChange={e => setSearch(e.target.value)} />
            <button type="submit"><FiSearch /></button>
          </form>
          {CATEGORIES.map(cat => (
            <Link
              key={cat.name}
              to={`/products?category=${encodeURIComponent(cat.name)}`}
              onClick={() => setMenuOpen(false)}
              className="mobile-nav-link"
            >
              {cat.icon} {cat.name}
            </Link>
          ))}
          <div className="mobile-divider" />
          <Link to="/cart"   onClick={() => setMenuOpen(false)} className="mobile-nav-link">🛒 Cart ({cartCount})</Link>
          {user ? (
            <>
              <Link to="/profile" onClick={() => setMenuOpen(false)} className="mobile-nav-link">👤 Profile</Link>
              <Link to="/orders"  onClick={() => setMenuOpen(false)} className="mobile-nav-link">📦 Orders</Link>
              {user.role === 'admin' && <Link to="/admin" onClick={() => setMenuOpen(false)} className="mobile-nav-link">⚙️ Admin</Link>}
              <button onClick={handleLogout} className="mobile-nav-link mobile-logout">Sign Out</button>
            </>
          ) : (
            <Link to="/login" onClick={() => setMenuOpen(false)} className="mobile-nav-link">Sign In / Register</Link>
          )}
        </div>
      )}
    </header>
  );
}
